export default "__VITE_ASSET__bopwBx6G__"